export const STAFFING_RISK_STATUS = {
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
};

export const STAFFING_PRIORIRY_ZONES_ALIASES = {
  SAFE: 'SAFE' as const,
  MONITORING: 'MONITORING' as const,
  CRITICAL: 'CRITICAL' as const,
};
